import { render, staticRenderFns } from "./o-article-header.vue?vue&type=template&id=5e649c77&scoped=true"
import script from "./o-article-header.vue?vue&type=script&lang=js"
export * from "./o-article-header.vue?vue&type=script&lang=js"
import style0 from "./o-article-header.vue?vue&type=style&index=0&id=5e649c77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e649c77",
  null
  
)

export default component.exports